exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap);", ""]);

// module
exports.push([module.id, "#app{max-width:100%!important;font-family:Quicksand,sans-serif;font-optical-sizing:auto;font-weight:400;font-style:normal}input[type=text]{border:none!important;border-color:transparent;margin-bottom:0}@media (min-width:1264px) and (max-width:1903px){.flex.lg5-custom{width:20%;max-width:20%;flex-basis:20%}}@media (min-width:1903px) and (max-width:4096px){.flex.lg5-custom{width:20%;max-width:20%;flex-basis:20%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-346d9de2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 19
// module chunks = 0